var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0126953,
    width: 45.9873,
    height: 45.9873,
    rx: 4,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8635 34.5034V24.0149H28.5613L29.1149 19.9274H24.8634V17.3176C24.8634 16.1342 25.2085 15.3277 26.9911 15.3277L29.2645 15.3267V11.6708C28.8713 11.6211 27.5217 11.5098 25.9518 11.5098C22.6739 11.5098 20.4298 13.4146 20.4298 16.9129V19.9274H16.7225V24.0149H20.4298V34.5033H24.8635V34.5034Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingFacebook);
export default __webpack_public_path__ + "static/media/landingFacebook.31b7ca61e13869bd690d00ec779a359a.svg";
export { ForwardRef as ReactComponent };